<template>
  <!-- 论文推荐-->
  <div class="commends">
    <div class="column_list">
      <img src="@/assets/image/notice.png" />
      <h3>公告/动态</h3>
    </div>
    <div class="thesis">
      <ul class="list_anonco">
        <li class="flex_left" v-for="(item, index) in Announ_list" :key="index">
          <div class="left_anonco" @click="delivst(item.id)">
            <div v-if="item.type == '公告'" class="cen_anonco">{{ item.type }}</div>
            <div v-else-if="item.type == '通知'" class="cen_anonco zix_anonco">
              {{ item.type }}
            </div>
            <p>{{ item.title }}</p>
          </div>
          <p class="right_anonco">{{ item.createTime }}</p>
        </li>
      </ul>
      <Page
        style="margin-top: 20px"
        :total="total"
        :current="perParams.pages"
        size="small"
        :page-size="perParams.pageSize"
        @on-change="changePage"
        @on-page-size-change="changePageSize"
        show-elevator
        show-total
        show-sizer
      />
    </div>
  </div>
</template>
<script>
var vm;
export default {
  data() {
    return {
      sousuo: "",
      Announ_list: [],
      perParams: {
        pages: 1,
        pageSize: 10,
      },
      total: 10,
    };
  },
  name: "commends",
  components: {},
  created() {
    vm = this;
  },
  mounted() {
    vm.annoud();
  },
  methods: {
    changePage(page) {
      vm.perParams.pages = page;
      vm.annoud();
    },
    changePageSize(page) {
      vm.perParams.pageSize = page;
      vm.annoud();
    },
    //公告接口调用
    annoud() {
      var data = {
        pageNo: vm.perParams.pages,
        pageSize: vm.perParams.pageSize,
        periodicalId: this.$store.state.qikanId,
        title: this.sousuo,
      };
      vm.$apis.manage.Announ(data).then((res) => {
        vm.Announ_list = res.content.list.list;
        vm.total = res.content.list.total;
        vm.Announ_list.map((item) => {
          item.createTime = item.createTime.replace(/-/g, "/").substring(0, 10);
        });
      });
    },
    // //公告接口调用
    // annoud() {
    //   var data = {
    //     pageNo: 1,
    //     pageSize: 5,
    //     periodicalId: "1297783010043576320",
    //   };
    //   vm.$apis.manage.Announ(data).then((res) => {
    //     vm.Announ_list = res.content.list.list;
    //     vm.Announ_list.map((item) => {
    //       item.createTime = item.createTime.replace(/-/g, "/").substring(0, 10);
    //     });
    //   });
    // },
    delivst(id) {
      vm.$router.push({
        path: "/carDetails",
        query: {
          id: id,
          editId: this.$store.state.cbianId,
          perId: this.$store.state.qikanId,
        },
      });
    },
  },
};
</script>
<style scoped>
.flex_left {
  display: flex;
  justify-content: space-between;
}
.commends {
  width: 100%;
  background: #ffffff;
  padding: 40px;
  margin-bottom: 20px;
}
.column_list {
  margin-top: 40px;
  padding-bottom: 18px;
  border-bottom: 1px solid #d0cece;
}
.column_list img {
  width: 26px;
  height: 26px;
  display: block;
  float: left;
}
.column_list h3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
  text-indent: 0.5em;
}
.thesis ul li {
  list-style: none;
  padding: 20px 0px 15px 0px;
  border-bottom: 1px solid #cccccc;
}
.thesis li:last-child {
  border-bottom: none;
}
.list_thesis {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.list_thesis:hover {
  color: #2150cb;
}
.flex_left span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.name_thesis {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.list_anonco li {
  width: 100%;
  list-style: none;
  border-bottom: 1px solid #d2d2d2;
  padding: 8px 0px 5px 0px;
}
.list_anonco li:last-child {
  border-bottom: none;
}
.left_anonco {
  position: relative;
  width: 70%;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
}
.left_anonco p {
  /* width: 50%; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.cen_anonco {
  width: 42px;
  height: 20px;
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
  color: #333333;
  margin-top: 5px;
  margin-right: 10px;
  border: 1px solid #2150cb;
  border-radius: 4px;
}
.zix_anonco {
  border: 1px solid #ff900c;
}
.dt_anonco {
  border: 1px solid #21b1cb;
}
.right_anonco {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
}
</style>
